<template>
  <div
    v-if="value && value.xAxis && value.xAxis.length && value.series && value.series.length"
    class="statistics__radar"
    ref="radar">
  </div>
  <div
    v-else
    :key="emptyKey"
    class="dashboard-empty__container">
    <i class="iconfont icon-nodata"></i>
    <div>暂无数据</div>
  </div>
</template>

<script>
  // 雷达图
  import {clone} from "../../../../assets/js/Untis"
  import current from "./mixin"

  export default {
    mixins: [current],
    data() {
      return {
        emptyKey: Math.random(),
        optConf: {
          tooltip: {
          },
          legend: {},
          radar: {
            indicator: []
          }, /*
           {
             indicator: [
              {
                name: '销售（sales）',
                axisLabel: {
                    show: true,
                    textStyle: {
                        fontSize: 18,
                        color: '#333'
                    }
                },
                max: 6500
               },
             ]
           }

          */
          series: null  /*
           {
        name: '预算 vs 开销（Budget vs spending）',
        type: 'radar',
        // areaStyle: {normal: {}},
        data: [
            {
                value: [4300, 10000, 28000, 35000, 50000, 19000],
                name: '预算分配（Allocated Budget）'
            },
            {
                value: [5000, 14000, 28000, 31000, 42000, 21000],
                name: '实际开销（Actual Spending）'
            }
        ]
    }
            * */
        },
        chart: null,
        loaded: false,
      }
    },
    computed: {},

    mounted() {
        if (this.$refs.radar) {
          const chart = this.$ECharts.init(this.$refs.radar)
          chart.title = ''
          this.chart = chart
          this.initChart()
        }

    },
    methods: {
      initChart() {
        this.$nextTick(() => {
          if (!this.chart && this.$refs.radar) {
            const chart = this.$ECharts.init(this.$refs.radar)
            chart.title = ''
            this.chart = chart
          }
          if (this.value && this.chart) {
            const opt = clone(this.optConf)
            opt.color = this.showPropertiesHolder.theme.value
            const showFieldsColor = this.showPropertiesHolder.showFieldsColor
            const value = this.value
            if (value && value.xAxis && value.xAxis.length && value.series && value.series.length) {
              opt.series = {
                type: 'radar',
              }

              opt.radar.indicator = value.xAxis.map((item, idx) => {

                let show = Boolean(this.showPropertiesHolder.showDataTag)
                return {
                  id: item.dataId,
                  name: item.name.showValue,
                  max: item.max,
                  axisLabel: {
                    show
                  }
                }
              })

              opt.series.data = value.series.map((item, idx) => {
                let color = ''
                if (showFieldsColor[item.dataId]) {
                  color = showFieldsColor[item.dataId]
                } else {
                  color = showFieldsColor[item.dataId] = opt.color[idx] || opt.color[0]
                }
                return {
                  id: item.dataId,
                  name: item.name,
                  value: item.value,
                  itemStyle: {
                    color
                  }
                }
              })

              // 显示图例配置
              if (this.showPropertiesHolder.showLegend) {
                opt.legend = this.showPropertiesHolder.legend.value
                if (opt.legend) {
                  opt.legend.data = value.series.map(item => item.name)
                }
              } else {
                opt.legend = null
              }

              this.chart.setOption(opt, true, false, true)
              this.resize()
            } else {
              this.chart.clear()
              this.emptyKey = Math.random()
              this.chart = null
            }
            this.chart.on('click', params => {
              console.log('click',params)
              this.showDataDrillDownList(params)
            });
          }
        })
      },
      // 重置或初始化图表实例
      resize() {
        this.$nextTick(() => {
          if (this.chart) {
            this.chart.resize()
          }
        })
      }
    },
    components: {},
    watch: {
      // value 发生修改时 重新渲染图表
      value() {
        this.initChart()
      }
    }
  }
</script>

<style rel="stylesheet" lang="less">
  .statistics__radar {
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
